'use client';

import { useEffect, useState } from 'react';

export function usePublicContent<T>(file: string, initial: T): T {
    const [data, setData] = useState<T>(initial);

    useEffect(() => {
        let active = true;

        void fetch(`/data/${file}.json`, { cache: 'no-store' })
            .then(async (response) => (response.ok ? ((await response.json()) as unknown) : null))
            .then((value) => {
                if (value !== null && active) {
                    setData(value as T);
                }
            })
            .catch(() => {});

        return () => {
            active = false;
        };
    }, [file]);

    return data;
}
